import React from 'react';

import { PartyTypes, Memberships, isNil, bind } from 'vdlib';
import MerchantDashboard from './MerchantDashboard';
import InsuranceDashboard from './InsuranceDashboard';
import AdminDashboard from './AdminDashboard';
import VDFMDocument from './GDPR/VDFMDocument';
import HydraDocument from './GDPR/HydraDocument';
import { getCountrySteps } from './GDPR/CountrySteps';
import '../../index.css';

import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';

import vdfmlogo from 'static/img/VDFM_small.png';
import { Skeleton, Steps, Checkbox } from 'antd';

const { Step } = Steps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNewAuctions: true,
      showGDPR: false,
      checkNoShowAgain: false,
      current: 0,
    };
  }

  componentDidMount() {
    this.props.fetchData();

    if (this.props.partyType.Description === PartyTypes.Merchant) {
      this.props.fetchNewAuctions();
    }

    if (window.sessionStorage.getItem('NewAuctions') === 'false')
      this.setState({ showNewAuctions: false });
  }

  componentDidUpdate(prevProps) {
    let partyType = this.props.partyType.Description;
    const { showNewAuctions } = this.state;

    if (
      !this.props.hasError &&
      this.props.data &&
      prevProps.data != this.props.data
    ) {
      if (this.props.data.ShowGDPR) {
        this.setState({ showGDPR: true });
      }
    }

    if (
      !this.props.hasError &&
      this.props.data &&
      prevProps.data != this.props.data
    ) {
      if (this.props.data.ShowGDPR) {
        this.setState({ showGDPR: true });
      }
    }
  }

  handleAccept = steps => {
    if (steps.length - 1 > this.state.current)
      this.setState({ current: this.state.current + 1 });
    else this.setState({ showGDPR: false });

    if (this.state.checkNoShowAgain) this.props.readGDPRData();
  };

  handleCheckBoxChange = e => {
    this.setState({ checkNoShowAgain: e.target.checked });
  };

  render() {
    const { showGDPR, current } = this.state;
    const { lang, loading, party, membership } = this.props;

    const steps = getCountrySteps(
      party.CountryID,
      this.handleAccept,
      this.props.partyType.Description
    );

    if (isNil(this.props.partyType)) return false;

    let partyType = this.props.partyType.Description;
    return (
      <div>
        {loading ? (
          <Skeleton active />
        ) : partyType === PartyTypes.Merchant ? (
          <MerchantDashboard
            lang={lang}
            {...this.props.data}
            NewAuctions={this.props.newAuctions}
          />
        ) : partyType === PartyTypes.Insurance ? (
          <InsuranceDashboard lang={lang} {...this.props.data} />
        ) : partyType === PartyTypes.Operator ||
          partyType === PartyTypes.Admin_Insurance ? (
          <AdminDashboard lang={lang} {...this.props.data} />
        ) : (
          false
        )}
        {showGDPR ? (
          <Modal
            visible={showGDPR}
            title={
              <div>
                <img src={vdfmlogo} alt="vdfmlogo" className="logo-default" />
                <span style={{ fontSize: 24 }}>GDPR Compliance</span>
              </div>
            }
            width={800}
            onCancel={this.handleReject}
            footer={null}
          >
            {partyType === PartyTypes.Merchant &&
            membership.Description !== Memberships.Trial ? (
              <>
                {' '}
                <Steps
                  current={current}
                  size="small"
                  style={{ width: steps.length * 150 }}
                >
                  {steps.map(item => (
                    <Step key={item.title} title={item.title} />
                  ))}
                </Steps>
                <div
                  className="steps-content"
                  style={{ paddingTop: 20, paddingBottom: 20 }}
                >
                  {steps[current].content}
                </div>
                <div className="steps-action">
                  <Checkbox onChange={this.handleCheckBoxChange}>
                    <span style={{ fontWeight: 600 }}>
                      Να μην εμφανιστεί ξανά αυτό το μήνυμα
                    </span>
                  </Checkbox>
                </div>
              </>
            ) : (
              <VDFMDocument
                showCheckBox={true}
                handleCheckBoxChange={this.handleCheckBoxChange}
                handleAccept={this.handleAccept}
              />
            )}
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default Dashboard;
